import React from 'react';
import ReviewSlides from '@/components/Common/LandingPage/ReviewSlides';
import './index.less';

const ReviewsCarousel = ({ title, signup }: { title?: string; signup?: () => void }) => {
  return (
    <div className="reviews">
      <span className="title">{title || 'The Reviews Are In'}</span>
      <ReviewSlides />
      {signup && (
        <span className="start-for-free" onClick={signup}>
          {' '}
          Start for free{' '}
        </span>
      )}
    </div>
  );
};

export default ReviewsCarousel;
